/*=========================================================================================
  File Name: moduleAuth.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleRelatedModuleNavigationState.js'
import mutations from './moduleRelatedModuleNavigationMutations.js'
import actions from './moduleRelatedModuleNavigationActions.js'
import getters from './moduleRelatedModuleNavigationGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
